module.exports = __webpack_public_path__ + "84ae77b20363826c862bf888102738bb.svg";